import { useContext } from "react";
import { useController } from "react-hook-form";
import { FormContext } from "components/shared/Form";
import RHFTextField from "components/ui/atoms/formFields/RHFTextField";
import { Box, IconButton, Stack } from "@mui/material";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import { useGetSummary } from "models/deals/apiDeal";
import { SnackbarContext } from "components/context/SnackbarProvider";

export const CommentSummaryField = ({ name, type, source, ...props }) => {
  const { displayError } = useContext(SnackbarContext);
  const {
    form: { watch, control },
  } = useContext(FormContext);
  const {
    field: { onChange },
  } = useController({
    control: control,
    name: name,
  });

  const { mutateAsync: getSummary } = useGetSummary({});
  const source_comment = watch(source);
  const magic = () => {
    getSummary(source_comment)
      .then((data) => onChange(data.summary))
      .catch(displayError);
  };

  return (
    <Stack direction={"row"}>
      <RHFTextField name={name} type={type} {...props} />
      <Box sx={{ ml: 2, display: "flex", alignItems: "center" }}>
        <IconButton variant="contained" size="small" onClick={() => magic()}>
          <AutoFixHighIcon />
        </IconButton>
      </Box>
    </Stack>
  );
};

export default CommentSummaryField;
